import React from "react";

export default function Logo({ compact = false, onDark = false }) {
  return (
    <div className="flex items-center gap-2.5" data-testid="app-logo">
      <img src="/logo-mark.png" alt="Thinkneural" className="w-9 h-9 object-contain shrink-0" />
      {!compact && (
        <span className={`font-display font-bold text-lg tracking-tight ${onDark ? "text-white" : "text-slate-900"}`}>
          Thinkneural
        </span>
      )}
    </div>
  );
}
